/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { AuthConfiguration, IptvLoginResponse } from 'client-code/iptv-login';
import { IptvLoginServiceRepositoryImpl } from '../impls/IptvLoginServiceRepositoryImpl';
import { IIptvLoginServiceRepository } from '../interfaces/IIptvLoginServiceRepository';

export class IptvLoginService implements IIptvLoginServiceRepository {
    private oIptvLoginServiceRepository: IptvLoginServiceRepositoryImpl;

    constructor() {
        this.oIptvLoginServiceRepository = new IptvLoginServiceRepositoryImpl();
    }

    static initialize(baseUrl: string) {
        IptvLoginServiceRepositoryImpl.initialize(baseUrl);
    }

    async fetchAndGetAuthConfiguration(): Promise<AuthConfiguration> {
        return this.oIptvLoginServiceRepository.fetchAndGetAuthConfiguration();
    }

    async getIptvLoginBySamlToken(samlToken: string): Promise<IptvLoginResponse> {
        return this.oIptvLoginServiceRepository.getIptvLoginBySamlToken(samlToken);
    }
}
